export default {
  name: 'Aselect',
  props: {
    label: { type: String, default: () => '' },
    value: { type: String | Number, default: () => undefined },
    size: { type: String, default: () => 'small' },
    default: { type: String, default: () => '0' },
    data: { type: Array, default: () => null },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
    placeholder: { type: String, default: () => '' },
  },
  data() {
    return {
      model: this.value,
    }
  },
  watch: {
    value(value) {
      if (value !== this.model) this.model = value;
    },
  },
  methods: {
    input(e) {
      this.$emit('input', e);
    },
    change(e) {
      this.$emit('change', e);
    }
  },
  render() {
    const { ...attrs } = this.$attrs;
    const data = this.options || this.option || this.config || this.items || this.data || [];
    return (
      <div class="a-select">
        {this.label && (<span class="a-select-label">{this.label}</span>)}
        <el-select v-model={this.model} size={this.size} placeholder={this.placeholder} on-input={this.input} on-change={this.change} {...{ attrs }}>
          {data.length > 0 && data.map((a, b) => {
            const label = a.label || a.title || a.text || a.name || a.key || a;
            const value = (`${a.value || a.code || a.val || a.id || a}`);
            return (<el-option key={b} label={label} value={value} />);
          })}
        </el-select>
      </div>
    );
  }
}